import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.horizontal-image-rows-cta' ).each( function( index, component ) {
        const splide0 = new Splide( $( component ).find( '.horizontal-image-rows-cta__images--0' )[0], {
          type: 'loop',
          pagination: false,
          arrows: false,
          gap: '12px',
          autoWidth: true,
          pauseOnHover: false,
          autoScroll: {
            speed: 0.5,
            autoStart: window.hasMotion ? true : false,
          },
        } );

        const splide1 = new Splide( $( component ).find( '.horizontal-image-rows-cta__images--1' )[0], {
          type: 'loop',
          pagination: false,
          arrows: false,
          gap: '12px',
          autoWidth: true,
          pauseOnHover: false,
          rtl: true,
          autoScroll: {
            speed: -0.5,
            autoStart: window.hasMotion ? true : false,
          },
        } );

        splide0.mount( {AutoScroll} );
        splide1.mount( {AutoScroll} );

        if ( !window.hasMotion ) {
          $( component ).find( '.loop-video-toggle-state' ).addClass( 'is-paused' );
        }

        $( component ).find( '.loop-video-toggle-state' ).on( 'click', function() {
          if ( $( this ).hasClass( 'is-paused' ) ) {
            splide0.Components.AutoScroll.play();
            splide1.Components.AutoScroll.play();
            $( this ).removeClass( 'is-paused' );
          } else {
            splide0.Components.AutoScroll.pause();
            splide1.Components.AutoScroll.pause();
            $( this ).addClass( 'is-paused' );
          }
        } );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'horizontal-image-rows-cta', COMPONENT );
} )( app );
